import React, { CSSProperties, useEffect, useState } from 'react'
import styled from 'styled-components'
import { ReactComponent as About2 } from 'ASSETS/svg/icon_about_2.svg'
import { ReactComponent as Feat2 } from 'ASSETS/svg/icon_feat_2.svg'
import { ReactComponent as Zoom } from 'ASSETS/svg/icon_zoom.svg'
import { ReactComponent as Cut } from 'ASSETS/svg/icon_cut.svg'
import { ReactComponent as HorizontalFlip } from 'ASSETS/svg/icon_horizontal_flip.svg'
import { ReactComponent as Watermask } from 'ASSETS/svg/icon_watermask.svg'
import feat2Img from 'ASSETS/png/feat2.png'

const FeatContainer2 = () => {
  const [cutActive, setCutActive] = useState(false)
  const [cutScale, setCutScale] = useState(1)
  const [zoomScale, setZoomScale] = useState(1)
  const [showMask, setShowMask] = useState(false)
  const [zoomActive, setZoomActive] = useState(false)
  const [scale, setScale] = useState(0.5)
  const [imgScale, setImgScale] = useState(1)

  const start = () => {
    setTimeout(() => {
      setCutActive(true)
    }, 200)
    setTimeout(() => {
      setCutScale(0.9)
    }, 400)
    setTimeout(() => {
      setCutScale(1)
    }, 600)
    setTimeout(() => {
      setShowMask(true)
      setScale(0.8)
    }, 1000)
    setTimeout(() => {
      setCutActive(false)
    }, 2000)
    setTimeout(() => {
      setZoomActive(true)
    }, 2200)
    setTimeout(() => {
      setZoomScale(0.9)
    }, 2400)
    setTimeout(() => {
      setZoomScale(1)
    }, 2600)
    setTimeout(() => {
      setImgScale(1.2)
    }, 3000)
    setTimeout(() => {
      setImgScale(1)
    }, 4200)
    setTimeout(() => {
      setZoomActive(false)
    }, 4400)
    setTimeout(() => {
      setShowMask(false)
      setScale(0.5)
    }, 4600)
    setTimeout(() => {
      start()
    }, 4800)
  }

  useEffect(() => {
    start()
  }, [])

  const actions: ActionProps[] = [
    {
      icon: Zoom,
      text: '缩放',
      style: { top: '311px', transform: `scale(${zoomScale})` },
      active: zoomActive,
    },
    {
      icon: Cut,
      text: '裁剪',
      style: { top: '366px', transform: `scale(${cutScale})` },
      active: cutActive,
    },
    { icon: HorizontalFlip, text: '翻转', style: { top: '421px' }, active: false },
    { icon: Watermask, text: '水印', style: { top: '476px' }, active: false },
  ]

  const width = 536
  const height = 524

  return (
    <div
      style={{
        background: '#f5f8ff',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Container>
        <IconFeat2></IconFeat2>
        <div style={{ width: '168px', alignSelf: 'flex-start', marginTop: '24px' }}>
          <FeatTitle>{`支持丰富的\n`}</FeatTitle>
          <FeatActiveTitle>智能处理</FeatActiveTitle>
          <FeatTitle>操作</FeatTitle>
        </div>
        <FeatContent>
          支持包括个性化裁剪、缩放、图文水印、格式压缩等多种智能处理编辑操作，丰富的 AI
          能力持续更新。
        </FeatContent>
        <Feat2Cube></Feat2Cube>
        <Feat2ImageContainer>
          <img
            src={feat2Img}
            style={{
              transform: `scale(${imgScale})`,
              transition: 'all ease 0.4s',
              objectFit: 'cover',
              height,
              width,
              position: 'absolute',
            }}
          ></img>
          <MaskGroup
            width={width * scale}
            height={height * scale}
            style={{
              borderLeftWidth: `${(width - width * scale) / 2}px`,
              borderRightWidth: `${(width - width * scale) / 2}px`,
              borderTopWidth: `${(height - height * scale) / 2}px`,
              borderBottomWidth: `${(height - height * scale) / 2}px`,
              opacity: showMask ? '1' : '0',
            }}
          ></MaskGroup>
        </Feat2ImageContainer>
        {actions.map((action) => {
          return <Feat2Action {...action} key={action.text}></Feat2Action>
        })}
      </Container>
    </div>
  )
}

const Container = styled.div`
  width: 343px;
  display: flex;
  height: 612px;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const IconFeat2 = styled(Feat2)`
  margin-top: 40px;
  align-self: flex-start;
  width: 40px;
  height: 40px;
  box-shadow: 1px 4px 20px rgba(184, 213, 240, 0.3);
  border-radius: 20px;
`

const FeatTitle = styled.span`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
  color: #282f38;
  white-space: pre-line;
`

const FeatActiveTitle = styled(FeatTitle)`
  color: #3370ff;
`

const FeatContent = styled.div`
  width: 323px;
  margin: 16px 0 32px 0;
  align-self: flex-start;
  font-size: 14px;
  line-height: 22px;
  color: #4e5a83;
  opacity: 0.8;
`

const Feat2Cube = styled.div`
  width: 254px;
  height: 262px;
  border-radius: 6px;
  background: #e6eefb;
  transform: translateX(23px);
  align-self: flex-start;
`

const Feat2ImageContainer = styled.div`
  position: absolute;
  top: 286px;
  left: 44px;
  width: 536px;
  height: 524px;
  border-radius: 12px;
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transform: scale(0.5);
  transform-origin: top left;
`

const Feat2ActionContainer = styled.div`
  height: 46px;
  width: 48px;
  border-radius: 4px;
  background: rgba(252, 250, 252, 0.9);
  backdrop-filter: blur(6px);
  box-sizing: border-box;
  position: absolute;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const Feat2ActionText = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
`

const MaskContainer = styled.div`
  position: relative;
  pointer-events: none;
  transition-timing-function: ease, cubic-bezier(0.68, -0.6, 0.32, 1.6);
  transition-property: opacity, all;
  transition-duration: 0.2s, 0.8s;
  border-color: rgba(21, 22, 25, 0.3);
  border-style: solid;
`

interface ActionProps {
  active: boolean
  style: CSSProperties
  icon: typeof About2
  text: string
}

const Feat2Action = (props: ActionProps) => {
  return (
    <Feat2ActionContainer
      style={{
        ...{
          backgroundColor: props.active ? '#3370FF' : 'rgba(252, 250, 252, 0.9)',
          transition: 'transform ease 0.2s',
        },
        ...props.style,
      }}
    >
      <props.icon
        fill={props.active ? 'white' : '#606A78'}
        width="13px"
        height="13px"
        style={{ marginBottom: '5px' }}
      ></props.icon>
      <Feat2ActionText style={{ color: props.active ? 'white' : '#606A78' }}>
        {props.text}
      </Feat2ActionText>
    </Feat2ActionContainer>
  )
}

const MaskGroup = (props: { width: number; height: number; style: CSSProperties }) => {
  return (
    <MaskContainer
      style={{ width: `${props.width}px`, height: `${props.height}px`, ...props.style }}
    >
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '1px',
          top: '0',
          backgroundImage: `linear-gradient(to bottom, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '1px',
          top: '33.3%',
          backgroundImage: `linear-gradient(to bottom, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '1px',
          top: '66.6%',
          backgroundImage: `linear-gradient(to bottom, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '1px',
          top: '100%',
          backgroundImage: `linear-gradient(to bottom, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '1px',
          left: '0px',
          top: '0px',
          backgroundImage: `linear-gradient(to right, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '1px',
          left: '33.3%',
          top: 0,
          backgroundImage: `linear-gradient(to right, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '1px',
          left: '66.6%',
          top: 0,
          backgroundImage: `linear-gradient(to right, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '1px',
          left: '100%',
          top: 0,
          backgroundImage: `linear-gradient(to right, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderLeft: '4px solid #FFFFFF',
          borderTop: '4px solid #FFFFFF',
          position: 'absolute',
          top: '-2px',
          left: '-2px',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderRight: '4px solid #FFFFFF',
          borderTop: '4px solid #FFFFFF',
          position: 'absolute',
          top: '-2px',
          right: '-2px',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderRight: '4px solid #FFFFFF',
          borderBottom: '4px solid #FFFFFF',
          position: 'absolute',
          right: '-2px',
          bottom: '-2px',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderLeft: '4px solid #FFFFFF',
          borderBottom: '4px solid #FFFFFF',
          position: 'absolute',
          left: '-2px',
          bottom: '-2px',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderLeft: '4px solid #FFFFFF',
          position: 'absolute',
          left: '-2px',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderRight: '4px solid #FFFFFF',
          position: 'absolute',
          right: '-2px',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      ></div>
    </MaskContainer>
  )
}

export default FeatContainer2
